import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";

const ProtectedAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/unauthorized" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    if (!decoded.is_staff) {
      return <Navigate to="/unauthorized" replace />;
    }
    return children;
  } catch (error) {
    localStorage.removeItem('token');
    return <Navigate to="/unauthorized" replace />;
  }
};

export default ProtectedAdminRoute;
